import React, { useState } from "react";
import DatePicker from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { BsCalendar, BsArrowRight } from "react-icons/bs";
import "./CsplDateRangePicker.css";

const CsplDateRangePicker = ({ fromDate, toDate, onGoClick }) => {
  const [showPicker, setShowPicker] = useState(false);

  const handleFromDateChange = (date) => {
    onGoClick(date, toDate);
  };

  const handleToDateChange = (date) => {
    onGoClick(fromDate, date);
  };

  const handleDoneClick = () => {
    if (fromDate > toDate) {
      alert("Start date must be smaller than or equal to end date.");
      return;
    }
    setShowPicker(false);
  };

  const handleResetClick = () => {
    setShowPicker(false);
    onGoClick(null, null);
  };

  const fromDateString = fromDate
    ? fromDate.toLocaleDateString()
    : "mm/dd/yyyy";
  const toDateString = toDate ? toDate.toLocaleDateString() : "mm/dd/yyyy";

  return (
    <div>
      <button className="date-range-button" onClick={() => setShowPicker(true)}>
        <span className="date-field">{fromDateString}</span>
        <BsArrowRight className="arrow-icon" />
        <span className="date-field">{toDateString}</span>
        <BsCalendar className="calendar-icon" />
      </button>
      {showPicker && (
        <div className="date-picker-popup">
          <div className="date-picker-header">
            <h5 className="select-range-text">Select date range</h5>
            <button
              className="reset-button transparent-button"
              onClick={handleResetClick}
            >
              Reset
            </button>
            <button className="done-button" onClick={handleDoneClick}>
              Done
            </button>
          </div>
          <div className="date-picker-content">
            <div className="calendar-container">
              <DatePicker onChange={handleFromDateChange} value={fromDate} />
            </div>
            <div className="calendar-container">
              <DatePicker onChange={handleToDateChange} value={toDate} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CsplDateRangePicker;
